iScreenWizard.factory('Etrainingmodule', function ($q, Ajax) {

    var data = {};

    data.all = function() {
        return $q(function (resolve, reject) {
            Ajax.get('etrainingmodule').then(function (response) {
                var etrainingmodules = response.data;
                resolve(etrainingmodules);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('etrainingmodule/'+id).then(function (response) {
                var etrainingmodule = response.data;
                resolve(etrainingmodule);
            }, reject);
        });
    };

    return data;
});